<template>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.75 2.23462H11"
      stroke="#656F9C"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.25 2.23462L1 2.23462"
      stroke="#656F9C"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.38377 1.35089C9.50316 1.4662 9.59839 1.60413 9.6639 1.75663C9.72941 1.90914 9.76389 2.07316 9.76533 2.23914C9.76678 2.40511 9.73515 2.56971 9.6723 2.72333C9.60945 2.87695 9.51663 3.01652 9.39926 3.13388C9.2819 3.25125 9.14233 3.34407 8.98871 3.40692C8.83509 3.46977 8.67049 3.5014 8.50452 3.49995C8.33855 3.49851 8.17452 3.46403 8.02202 3.39852C7.86951 3.33301 7.73158 3.23778 7.61627 3.11839C7.38857 2.88264 7.26258 2.56688 7.26543 2.23914C7.26828 1.91139 7.39974 1.59788 7.6315 1.36612C7.86326 1.13436 8.17677 1.0029 8.50452 1.00005C8.83227 0.9972 9.14802 1.12319 9.38377 1.35089Z"
      stroke="#656F9C"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.75 5.98462H11"
      stroke="#656F9C"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.25 5.98462H1"
      stroke="#656F9C"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.61617 6.86835C2.49678 6.75304 2.40155 6.61511 2.33604 6.4626C2.27053 6.3101 2.23605 6.14607 2.23461 5.9801C2.23316 5.81413 2.26479 5.64953 2.32764 5.49591C2.39049 5.34229 2.48331 5.20272 2.60067 5.08535C2.71804 4.96799 2.85761 4.87517 3.01123 4.81232C3.16485 4.74947 3.32945 4.71784 3.49542 4.71929C3.66139 4.72073 3.82542 4.75521 3.97792 4.82072C4.13043 4.88623 4.26836 4.98146 4.38367 5.10085C4.61137 5.3366 4.73736 5.65235 4.73451 5.9801C4.73166 6.30785 4.6002 6.62136 4.36844 6.85312C4.13668 7.08488 3.82317 7.21634 3.49542 7.21919C3.16767 7.22204 2.85192 7.09605 2.61617 6.86835Z"
      stroke="#656F9C"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.75 9.73462H11"
      stroke="#656F9C"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.25 9.73462H1"
      stroke="#656F9C"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.38377 8.85089C9.50316 8.9662 9.59839 9.10413 9.6639 9.25663C9.72941 9.40914 9.76389 9.57316 9.76533 9.73914C9.76678 9.90511 9.73515 10.0697 9.6723 10.2233C9.60945 10.377 9.51663 10.5165 9.39926 10.6339C9.2819 10.7512 9.14233 10.8441 8.98871 10.9069C8.83509 10.9698 8.67049 11.0014 8.50452 11C8.33855 10.9985 8.17452 10.964 8.02202 10.8985C7.86951 10.833 7.73158 10.7378 7.61627 10.6184C7.38857 10.3826 7.26258 10.0669 7.26543 9.73914C7.26828 9.41139 7.39974 9.09788 7.6315 8.86612C7.86326 8.63436 8.17677 8.50289 8.50452 8.50005C8.83227 8.4972 9.14802 8.62319 9.38377 8.85089Z"
      stroke="#656F9C"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
